import React from "react";
import moment from "moment";
import { useSelector } from 'react-redux';
import { translator } from '../../utils/Translator';

const DisplayDate = ({date}) => {
  const { translate } = useSelector(({ i18n }) => i18n);
  const postDate = moment(date, 'ddd MMM DD YYYY kk:mm:ss Z');
  const currentDate = moment(new Date());
  const duration = moment.duration(currentDate.diff(postDate));
  const minutes = (duration.asMinutes() | 0);
  const hours = (duration.asHours() | 0);

  switch (true) {
    case minutes === 0:
      return <p className="jr-text-grey jr-fs-sm jr-mb-0">{translator(translate.ISA_Just_now, "Just now")}</p>;
    case minutes < 60:
      return <p className="jr-text-grey jr-fs-sm jr-mb-0">{minutes} {translator(translate.ISA_Minutes, "นาที")}</p>;
    case hours < 24:
      return <p className="jr-text-grey jr-fs-sm jr-mb-0">{hours} {translator(translate.ISA_Hours, "ชั่วโมง")}</p>;
    default:
      return <p className="jr-text-grey jr-fs-sm jr-mb-0">{postDate.format("DD MMM, YYYY")}</p>
  }
};

export default DisplayDate;
